<script>

import WithdrawalRequestModal from "@/components/modals/WithdrawalRequestModal.vue";
import TokenTransactionsTable from "@/components/tokenTransactions/TokenTransactionsTable.vue";

export default {
    components: {TokenTransactionsTable, WithdrawalRequestModal},

    data() {
        return {
            withdrawModalOpened: false,
            tokenTransactions: [],
            loading: {
                tokenTransactions: true,
                data: true
            },
            controller: {
                tokenTransactions: null,
            },
            data: null,
        }
    },
    methods: {
        openWithdrawModal() {
            this.withdrawModalOpened = true;
            this.$modal.open();
        },
        closeWithdrawModal(data) {
            if (data && data.requestSent) {
                this.loadDashboardData();
                this.loadTokenTransactions();
            }
            this.$modal.close();
            this.withdrawModalOpened = false;
        },
        loadTokenTransactions() {
            this.controller.tokenTransactions = new AbortController();
            axios.get('/token-transactions', {
                signal: this.controller.tokenTransactions.signal,
                params: {
                    per_page: 10,
                    page: 1
                }
            }).then(response => {
                this.tokenTransactions = response.data.data;
            }).finally(() => {
                this.loading.tokenTransactions = false;
            })
        },
        loadDashboardData() {
            this.controller.dashboard = new AbortController();
            axios.get('/dashboard', {
                signal: this.controller.dashboard.signal
            }).then(response => {
                this.data = response.data;
            }).finally(() => {
                this.loading.data = false;
            })
        },
        download(transaction) {
            transaction.downloading = true;
            axios({
                url: '/token-transactions/' + transaction.id + '/confirmation',
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                saveAs(response.data, `potwierdzenie-transakcji-${transaction.id}.pdf`);
            }).finally(() => {
                transaction.downloading = false;
            });
        },
    },
    mounted() {
        this.loadTokenTransactions();
        this.loadDashboardData();
    }
}
</script>

<template>
    <section class="dashboard">
        <loader :loading="loading.data"></loader>
        <div v-if="!loading.data" class="block">

            <div class="info-cards-container mb-6 mt-6 is-flex is-justify-content-center is-align-items-stretch">
                <div class="card info-card has-text-centered is-align-content-center">
                    <div class="card-content">
                        <div class="title is-3 mb-4">{{ data.token_balance }} </div>
                        <div class="subtitle is-6">{{ $t('users.fields.token_balance.name')}}</div>
                    </div>
                </div>
                <div class="card info-card has-text-centered is-align-content-center">
                    <div class="card-content">
                        <div class="title is-3" v-bind:class="{'mb-4': data.tax_to_pay <= 0}">
                            {{ data.funds_to_receive }} zł
                        </div>
                        <div class="subtitle is-5" v-if="data.tax_to_pay > 0">
                            ({{ $t('dashboard.employee.including_tax') }}: {{ data.tax_to_pay }} zł)
                        </div>
                        <div class="subtitle is-6">{{ $t('dashboard.employee.awaiting_withdrawal') }}</div>
                    </div>
                </div>
            </div>

            <button class="button is-primary"
                    v-if="$auth.user.companies.length > 0"
                    v-bind:disabled="data.token_balance <= 0"
                    @click="openWithdrawModal">
                {{ $t('dashboard.employee.send_exchange_tokens') }}
            </button>

            <WithdrawalRequestModal v-if="withdrawModalOpened" v-on:close="closeWithdrawModal"/>
        </div>

        <div class="block">
            <div class="section-title is-size-5 is-uppercase">
                {{ $t('dashboard.labels.last_transactions') }}
            </div>
            <loader :loading="loading.tokenTransactions"/>
            <div class="block has-text-grey has-text-centered mb-4 mt-4" v-if="tokenTransactions.length === 0 && !loading.tokenTransactions">
                {{ $t('dashboard.labels.no_transactions') }}
            </div>
            <TokenTransactionsTable
                v-if="tokenTransactions.length"
                :data="tokenTransactions"
                :loading="loading.tokenTransactions"
                :detailsView="false"
                :show-per-page="false"
                :paginated="false"
            />
        </div>

    </section>
</template>
